import styled, { css, FlattenSimpleInterpolation } from 'styled-components';

export const StyledDurationInput = styled.input`
  font-size: inherit;
  font-family: inherit;
  font-weight: inherit;
  color: inherit;
  background: none;
  margin: 0;
  padding: 0;
  display: block;
  max-width: 300px;
  width: 100%;
  height: 48px;
  border-width: 1px;
  border-style: solid;
  border-color: ${({ theme }): string => theme.palette_gray_5};
  border-radius: ${({ theme }): string => theme.border_radius_x1};
  padding-left: ${({ theme }): string => theme.spacing_unit_x2};
  padding-right: ${({ theme }): string => theme.spacing_unit_x2};
  box-sizing: border-box;

  ${({ theme, disabled }): FlattenSimpleInterpolation | string => {
    if (disabled !== true) {
      return '';
    }

    return css`
      color: ${theme.palette_gray_60};
      background-color: ${theme.palette_gray_5};
    `;
  }}

  &:focus {
    outline-style: solid;
    outline-width: 2px;
    outline-color: ${({ theme }): string => theme.palette_blue_5};
  }
`;
